import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function DialogExportEVA({ open, onCancel, onSave }) {
  const [period, setPeriod] = React.useState("");
  function handleChange(event) {
    setPeriod(event.target.value);
  }

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Export Project</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please enter a period to export your Earned Value Analysis:
        </DialogContentText>
        <TextField
          autoComplete="off"
          autoFocus
          margin="dense"
          id="period"
          label="Period to Export"
          type="text"
          value={period}
          onChange={handleChange}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onCancel();
            setPeriod("");
          }}
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSave(period);
            setPeriod("");
          }}
          color="primary"
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default DialogExportEVA;
